import { Grid } from "antd";
import { useTranslation } from "react-i18next";
import { CoachList, NormalBanner, Title } from "../../../../components";
import { ContentWrapper } from "../../../../layouts/components";
import { useCoachesContext } from "../../context/CoachesContext";
import SkillsFilter from "../SkillsFilter";
import styles from "./styleModule";

const CoachesContainer = () => {
  const { filterCoachList } = useCoachesContext();
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <>
      <NormalBanner />
      <ContentWrapper>
        <div className={styles.coachesContainer}>
          <div
            className={`${styles.titleContainer} ${
              screens.sm ? "" : styles.mobile
            }`}
          >
            <Title
              title={t("coach.title.snow")}
              subtitle={t("coach.subtitle")}
            />
          </div>
          <SkillsFilter />
          <CoachList coachList={filterCoachList} />
        </div>
      </ContentWrapper>
    </>
  );
};

export default CoachesContainer;
